// ForgotPasswordPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/auth.css';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email.trim() })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Failed to send reset link');
            }

            setMessage(data.message);
            setError('');
        } catch (err) {
            setError(err.message || 'Failed to send reset link');
            setMessage('');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h2>Resetovanje Lozinke</h2>
                {message && <div className="success-message">{message}</div>}
                {error && <div className="error-message">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="email"
                            placeholder="Unesite vaš email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="auth-button">
                        Pošalji reset link
                    </button>
                </form>
                <button
                    onClick={() => navigate('/login')}
                    className="auth-link-button"
                >
                    Nazad na prijavu
                </button>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;